import { ACCESS_CODES, ACCESS_CODE_DETAILS, ACCESS_CODE_STATUS, ACCESS_CODE_STATS } from '../config/api';
import { apiCall } from './api';

// Get all access codes with optional parameters
export const getAccessCodes = async (params = {}) => {
  try {
    const response = await apiCall(ACCESS_CODES, {
      method: 'GET',
      ...(Object.keys(params).length > 0 && { data: params })
    });
    
    return response;
  } catch (error) {
    console.error('Error fetching access codes:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch access codes',
      data: null
    };
  }
};

// Get access code by ID
export const getAccessCodeById = async (accessCodeId) => {
  try {
    const endpoint = ACCESS_CODE_DETAILS.replace('{id}', accessCodeId);
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching access code:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch access code',
      data: null
    };
  }
};

// Create new access code
export const createAccessCode = async (accessCodeData) => {
  try {
    const response = await apiCall(ACCESS_CODES, {
      method: 'POST',
      data: accessCodeData
    });
    return response;
  } catch (error) {
    console.error('Error creating access code:', error);
    return {
      success: false,
      error: error.message || 'Failed to create access code',
      data: null
    };
  }
};

// Update existing access code
export const updateAccessCode = async (accessCodeId, accessCodeData) => {
  try {
    const endpoint = ACCESS_CODE_DETAILS.replace('{id}', accessCodeId);
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: accessCodeData
    });
    return response;
  } catch (error) {
    console.error('Error updating access code:', error);
    return {
      success: false,
      error: error.message || 'Failed to update access code',
      data: null
    };
  }
};

// Delete access code
export const deleteAccessCode = async (accessCodeId) => {
  try {
    const endpoint = ACCESS_CODE_DETAILS.replace('{id}', accessCodeId);
    const response = await apiCall(endpoint, {
      method: 'DELETE'
    });
    return response;
  } catch (error) {
    console.error('Error deleting access code:', error);
    return {
      success: false,
      error: error.message || 'Failed to delete access code',
      data: null
    };
  }
};

// Toggle access code status (activate/deactivate)
export const toggleAccessCodeStatus = async (accessCodeId, status) => {
  try {
    const endpoint = ACCESS_CODE_STATUS.replace('{id}', accessCodeId);
    const response = await apiCall(endpoint, {
      method: 'PATCH',
      data: { status }
    });
    return response;
  } catch (error) {
    console.error('Error toggling access code status:', error);
    return {
      success: false,
      error: error.message || 'Failed to toggle access code status',
      data: null
    };
  }
};

// Get access code statistics
export const getAccessCodeStats = async () => {
  try {
    const response = await apiCall(ACCESS_CODE_STATS, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching access code stats:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch access code stats',
      data: null
    };
  }
};
